<template>
	<div class="container">
		<!-- 筛选 -->
		<div>
			<el-form :inline="true" :model="filters">
				<el-form-item :label="$t('Operator')" v-show="zong">
					<el-select v-model="filters.SellerId" @change="changeSellerId" :placeholder="$t('Operator')" style="width: 150px"
							   >
						<el-option v-for="item in seller" :key="item.SellerId" :label="item.SellerName"
								   :value="item.SellerId"> </el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('channel')">
					<el-select v-model="filters.ChannelId" :placeholder="$t('channel')" style="width: 150px" clearable
							     >
						<el-option v-for="item in channel" :key="item.ChannelId" :label="item.Name" :value="item.ChannelId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('AgentID')+':'">
					<el-input v-model="filters.UserId" style="width: 150px" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-refresh" @click="handleQuery">{{ $t('Search') }}</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!-- 表 -->
		<div>
			<el-table :data="table_data" border class="table" :cell-style="{ padding: '0' }">
				<el-table-column align="center" prop="UserId" :label="$t('AgentID')" width="80"></el-table-column>
				<el-table-column align="center" prop="SellerName" :label="$t('Operator')" width="80" v-if="zong"></el-table-column>
				<el-table-column align="center" :label="$t('Channel')" width="80" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{ channelmap[scope.row.ChannelId] }}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="ChildCount" :label="$t('TotalNumberPeople')" width="80"></el-table-column>
				<el-table-column align="center" prop="DictChildCount" :label="$t('DirectPlayers')" width="80"></el-table-column>
				<el-table-column align="center" prop="Ip" :label="$t('TeamErformance')+'(U/T)'" width="110">
					<template slot-scope="scope"> {{ `${scope.row.TotalLiuSuiUsdt} / ${scope.row.TotalLiuSuiTrx}` }}
					</template>
				</el-table-column>
				<el-table-column align="center" prop="Opt" :label="$t('TeamBet')+'(U/T)'" width="110">
					<template slot-scope="scope"> {{ `${scope.row.TotalBetUsdt} / ${scope.row.TotalBetTrx}` }} </template>
				</el-table-column>
				<el-table-column align="center" prop="Opt" :label="$t('TeamRebate')+'(U/T)'" width="110">
					<template slot-scope="scope"> {{ `${scope.row.TotalRewardUsdt} / ${scope.row.TotalRewardTrx}` }}
					</template>
				</el-table-column>
				<el-table-column align="center" prop="Opt" :label="$t('DirectSubordinate')+'(U/T)'" width="110">
					<template slot-scope="scope"> {{ (Math.floor((scope.row.TotalBetUsdt - scope.row.TotalRewardUsdt -
						scope.row.GetedCommissionUsdt) * 100) / 100).toFixed(2) }} / {{ (Math.floor((scope.row.TotalBetTrx -
		scope.row.TotalRewardTrx - scope.row.GetedCommissionTrx) * 100) / 100).toFixed(2) }} </template>
				</el-table-column>
				<el-table-column :label="$t('BetAmount')">
					<el-table-column align="center" prop="Opt" :label="$t('Individual')" width="80">
						<template slot-scope="scope"> {{ `${scope.row.SelfBetUsdt} / ${scope.row.SelfBetTrx}` }} </template>
					</el-table-column>
					<el-table-column align="center" prop="Opt" :label="$t('RebateAmount')" width="100">
						<template slot-scope="scope"> {{ `${scope.row.DictBetUsdt} / ${scope.row.DictBetTrx}` }} </template>
					</el-table-column>
				</el-table-column>
				<el-table-column :label="$t('payoutAmount')+'(U/T)'">
					<el-table-column align="center" prop="Opt" :label="$t('Individual')" width="100">
						<template slot-scope="scope"> {{ `${scope.row.SelfRewardUsdt} / ${scope.row.SelfRewardTrx}` }}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="Opt" :label="$t('RebateAmount')" width="100">
						<template slot-scope="scope"> {{ `${scope.row.DictRewardUsdt} / ${scope.row.DictRewardTrx}` }}
						</template>
					</el-table-column>
				</el-table-column>
				<el-table-column :label="$t('performance')+'(U/T)'">
					<el-table-column align="center" prop="Opt" :label="$t('Individual')" width="100">
						<template slot-scope="scope"> {{ `${scope.row.SelfLiuSuiUsdt} / ${scope.row.SelfLiuSuiTrx}` }}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="Opt" :label="$t('RebateAmount')" width="100">
						<template slot-scope="scope"> {{ `${scope.row.DictLiuSuiUsdt} / ${scope.row.DictLiuSuiTrx}` }}
						</template>
					</el-table-column>
				</el-table-column>
				<el-table-column  :label="$t('Actions')" width="160">
					<template slot-scope="scope">
						<el-button type="text" icon="el-icon-document-copy" @click="showAgentDialog(scope.row, 5)">{{$t('SetRevenueShare')}}
						</el-button>
						<el-button type="text" icon="el-icon-document-copy" @click="showAgentDialog(scope.row, 3)">{{$t('ReductionCompensation')}}
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
							   :total="total" @current-change="handleCurrentChange" :page-size="pagesize"
							   :page-sizes="pagesizes" :current-page="current_row"> </el-pagination>
			</div>
		</div>
		<fencheng :show.sync="fenchengVisible" :list="info"></fencheng>
		<JiangPei ref="jp" />
		<StopJiangPei ref="stopjp" />
		<OddSetting :show.sync="oddSettingVisible" :id="Number(info.UserId)" v-if="oddSettingVisible"></OddSetting>
	</div>
</template>
<script>
import { app } from '@/api/app.js'
import base from '@/api/base.js'
import '@/assets/css/k.css'
import fencheng from './Dialog/fencheng.vue'
import JiangPei from '../components/jiangpei.vue'
import StopJiangPei from '../components/stopjiangpei.vue'
import OddSetting from './Dialog/oddSetting.vue'
export default {
	extends: base,
	name: 'agentTop',
	data() {
		return {
			filters: {
				UserId: null,
			},
			fenchengVisible: false,
			jiangpeiVisible: false,
			oddSettingVisible: false,
			info: {},
		}
	},
	components: {
		fencheng,
		JiangPei,
		StopJiangPei,
		OddSetting,
	},
	created() {
		this.app = app
		this.getChannel(this.filters.SellerId)
		this.getList()
	},
	methods: {
		getList() {
			this.info = {}
			const data = {
				Page: this.page,
				PageSize: this.pagesize,
				UserId: Number(this.filters.UserId),
				SellerId: this.filters.SellerId,
				ChannelId: Number(this.filters.ChannelId),
			}
			app.post('/agent/topagent_list', data, (res) => {
				this.total = res.data.total
				this.table_data = res.data.data
				for (let i = 0; i < this.table_data.length; i++) {
					for (let j = 0; j < this.seller.length; j++) {
						if (this.seller[j].SellerId == this.table_data[i].SellerId) this.table_data[i].SellerName = this.seller[j].SellerName
					}
				}
			})
		},
		handleQuery() {
			this.page = 1
			this.getList()
		},
		handleSizeChange(val) {
			this.pagesize = val
			this.getList()
		},
		handleCurrentChange(val) {
			this.page = val
			this.getList()
		},
		showAgentDialog(item, index) {
			this.info = JSON.parse(JSON.stringify(item))
			switch (index) {
				case 3:
					this.$refs.jp.showDialog(this.info.SellerId, 0, this.info.UserId, 0, 0, item.ChannelId)
					break
				case 5:
					this.oddSettingVisible = true
			}
		},
	},
}
</script>
